const SESSION_ERROR =
  'Не удалось обновить сессию. Обновите страницу и попробуйте ещё раз.'
const RESPONSE_ERROR =
  'Сервис вернул некорректный ответ. Обновите страницу и попробуйте ещё раз.'

let tokenRefresh: Promise<void> | null = null

export function csrfToken(): string {
  return (
    document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
      ?.content || ''
  )
}

async function readJson(response: Response): Promise<unknown> {
  if (!response.headers.get('content-type')?.includes('application/json')) {
    throw new Error(RESPONSE_ERROR)
  }

  try {
    return await response.json()
  } catch {
    throw new Error(RESPONSE_ERROR)
  }
}

async function refreshToken(): Promise<void> {
  if (!tokenRefresh) {
    tokenRefresh = (async () => {
      try {
        const response = await fetch('/api/csrf', {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          mode: 'same-origin',
          cache: 'no-store'
        })
        const data = (await readJson(response)) as {
          csrf_token?: unknown
        } | null
        if (
          !response.ok ||
          typeof data?.csrf_token !== 'string' ||
          !data.csrf_token
        ) {
          throw new Error(SESSION_ERROR)
        }

        let meta = document.querySelector<HTMLMetaElement>(
          'meta[name="csrf-token"]'
        )
        if (!meta) {
          meta = document.createElement('meta')
          meta.name = 'csrf-token'
          document.head.append(meta)
        }
        meta.content = data.csrf_token
      } catch {
        throw new Error(SESSION_ERROR)
      }
    })().finally(() => {
      tokenRefresh = null
    })
  }

  await tokenRefresh
}

/**
 * Повторяем только CSRF-отказ: Rails ещё не запускал действие контроллера.
 * @param {string} url
 * @param {unknown} payload
 */
export async function postJson<T>(
  url: string,
  payload: unknown
): Promise<{ response: Response; data: T }> {
  const body = JSON.stringify(payload)
  const send = async (token: string) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        ...(token ? { 'X-CSRF-Token': token } : {})
      },
      credentials: 'same-origin',
      mode: 'same-origin',
      body
    })
    return { response, data: await readJson(response) }
  }
  const expired = (result: { response: Response; data: unknown }) =>
    result.response.status === 422 &&
    (result.data as { error_code?: unknown } | null)?.error_code ===
      'csrf_expired'

  const token = csrfToken()
  let result = await send(token)
  if (expired(result)) {
    // Один GET для одновременных отказов тарифа и брони. Если другой запрос
    // уже обновил meta-тег, используем его токен без нового обновления сессии.
    if (tokenRefresh || csrfToken() === token) await refreshToken()
    result = await send(csrfToken())
    if (expired(result)) throw new Error(SESSION_ERROR)
  }

  return { response: result.response, data: result.data as T }
}
